<template>
  <v-container fluid class="fill-height">
    <v-row>
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
          class="grey lighten-5"
          style="height: 100%"
        >
          <v-card class="ma-3 pa-2 not-found" outlined>
            <v-card-title>Signing Out...</v-card-title>
            <v-card-text>Processing request </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.not-found {
  position: absolute;
  width: 100%;
  max-width: 400px;
  line-break: normal !important;
}
</style>
<script>
import userActions from "@/bin/aws/userActions";

export default {
  async mounted() {
    await userActions.signout();
    window.location = "/";
  }
};
</script>
